import { PortableTextBlock } from '@portabletext/react'
import clsx from 'clsx'
import { Button, ContentEditor, Heading } from '~/components'
import { SanityButtonProps, SanityImage } from '~/types'

interface StepsProps {
  alignment?: 'left' | 'center' | 'right'
  content?: PortableTextBlock[]
  segments: {
    image: SanityImage
    title?: string
    description?: string
  }[]
  button: SanityButtonProps
}

export default function BlockSteps({
  alignment = 'left',
  content = [],
  segments = [],
  button,
}: StepsProps) {
  return (
    <section
      className={clsx('container px-8 py-12 lg:px-16', {
        'text-left': alignment === 'left',
        'text-center': alignment === 'center',
        'text-right': alignment === 'right',
      })}
    >
      {content && (
        <div className="flex justify-center text-center">
          <ContentEditor content={content} />
        </div>
      )}

      <div className="mt-8 grid grid-cols-1 gap-6 lg:grid-cols-3">
        {segments.map((segment, index) => (
          <div
            key={index}
            className="text-center"
          >
            {segment.image?.asset?.url && (
              <img
                className="mx-auto h-auto w-full"
                src={segment.image.asset.url}
                alt={segment.image.alt}
              />
            )}
            <Heading
              tag="h3"
              size="h4"
              bold={false}
              className="mt-8 text-gold-500"
            >
              {index + 1}.
            </Heading>
            {segment.title && (
              <Heading
                tag="h3"
                size="h4"
                bold={false}
              >
                {segment.title}
              </Heading>
            )}
            {segment.description && (
              <p className="mt-1 text-gray-600">{segment.description}</p>
            )}
          </div>
        ))}
      </div>

      <div className="mt-16 flex justify-center">
        <Button
          size="text-base"
          {...button}
        />
      </div>
    </section>
  )
}
